import React from 'react';
import { useImperativeHandle } from 'react';
import { forwardRef } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const GoogleRecaptcha = forwardRef((props, ref) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useImperativeHandle(ref, () => ({
    async execute() {
      if (!executeRecaptcha) return;
      const token = await executeRecaptcha('submit');
      if (typeof props.validate === 'function') {
        props.validate(token);
      }
    },
  }));

  return null;
});

export default GoogleRecaptcha;
